
// import { useState, useEffect } from 'react';
// import Sidebar from './Sidebar/Sidebar';
// import Header  from './Header/Header';
// import Footer  from './Footer/Footer';
// import styles  from './Layout.module.scss';

// const SIDEBAR_EXPANDED  = 240;
// const SIDEBAR_COLLAPSED = 62;
// const BP_MOBILE         = 768;
// const BP_AUTO_COLLAPSE  = 1280;

// const Layout = ({ children }) => {
//     // collapsed = user's manual JS toggle state
//     const [collapsed, setCollapsed] = useState(false);

//     const [isMobile, setIsMobile] = useState(
//         () => window.innerWidth < BP_MOBILE
//     );
//     const [autoCollapsed, setAutoCollapsed] = useState(
//         () => window.innerWidth < BP_AUTO_COLLAPSE
//     );

//     useEffect(() => {
//         const onResize = () => {
//             const w = window.innerWidth;
//             setIsMobile(w < BP_MOBILE);
//             setAutoCollapsed(w < BP_AUTO_COLLAPSE);
//         };
//         window.addEventListener('resize', onResize);
//         return () => window.removeEventListener('resize', onResize);
//     }, []);

//     const toggleSidebar = () => setCollapsed(prev => !prev);

//     // Match Sidebar's own isDesktopCollapsed logic exactly
//     const isDesktopCollapsed = !isMobile && (autoCollapsed || collapsed);
//     const showLabel          = isMobile ? false : !isDesktopCollapsed;

//     const sidebarWidth = isMobile
//         ? 0
//         : showLabel
//             ? SIDEBAR_EXPANDED
//             : SIDEBAR_COLLAPSED;

//     return (
//         <div className={styles.layout}>

//             <Sidebar
//                 collapsed={collapsed}
//                 onToggle={toggleSidebar}
//             />

//             <div
//                 className={styles.mainContent}
//                 style={{
//                     marginLeft: `${sidebarWidth}px`,
//                     width     : `calc(100% - ${sidebarWidth}px)`,
//                     maxWidth  : `calc(100% - ${sidebarWidth}px)`,
//                 }}
//             >
//                 <Header
//                     onMenuClick={toggleSidebar}
//                     sidebarCollapsed={!showLabel}
//                     sidebarWidth={sidebarWidth}
//                 />

//                 <main className={styles.content}>
//                     {children}
//                 </main>

//                 <Footer />
//             </div>

//         </div>
//     );
// };

// export default Layout;
import { useState, useEffect, useCallback } from 'react';  // ← add useCallback
import Sidebar from './Sidebar/Sidebar';
import Header  from './Header/Header';
import Footer  from './Footer/Footer';
import styles  from './Layout.module.scss';

const SIDEBAR_EXPANDED  = 240;
const SIDEBAR_COLLAPSED = 62;
const BP_MOBILE         = 768;
const BP_AUTO_COLLAPSE  = 1280;

const Layout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);

    const [isMobile, setIsMobile] = useState(
        () => window.innerWidth < BP_MOBILE
    );
    const [autoCollapsed, setAutoCollapsed] = useState(
        () => window.innerWidth < BP_AUTO_COLLAPSE
    );

    useEffect(() => {
        const onResize = () => {
            const w = window.innerWidth;
            setIsMobile(w < BP_MOBILE);
            setAutoCollapsed(w < BP_AUTO_COLLAPSE);
        };
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const toggleSidebar = () => setCollapsed(prev => !prev);
    const handleOpen    = useCallback(() => setCollapsed(false), []); // ← added

    // FIXED: matches the corrected isDesktopCollapsed in Sidebar
    const isDesktopCollapsed = !isMobile && (autoCollapsed ? !collapsed : collapsed); // ← FIXED
    const showLabel          = isMobile ? false : !isDesktopCollapsed;

    const sidebarWidth = isMobile
        ? 0
        : showLabel
            ? SIDEBAR_EXPANDED
            : SIDEBAR_COLLAPSED;

    return (
        <div className={styles.layout}>

            <Sidebar
                collapsed={collapsed}
                onToggle={toggleSidebar}
                onOpen={handleOpen}        // ← added
            />

            <div
                className={styles.mainContent}
                style={{
                    marginLeft: `${sidebarWidth}px`,
                    width     : `calc(100% - ${sidebarWidth}px)`,
                    maxWidth  : `calc(100% - ${sidebarWidth}px)`,
                }}
            >
                <Header
                    onMenuClick={toggleSidebar}
                    sidebarCollapsed={!showLabel}
                    sidebarWidth={sidebarWidth}
                />

                <main className={styles.content}>
                    {children}
                </main>

                <Footer />
            </div>

        </div>
    );
};

export default Layout;
